import * as Sentry from "@sentry/react";
import { PropsWithChildren } from "react";

import { Error500, Error500Props } from "./Error500";

type ErrorBoundaryProps = PropsWithChildren<Omit<Error500Props, "errorData">>;

export const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const { showHelpLinks, children } = props;

  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <Error500
          showHelpLinks={showHelpLinks}
          errorData={import.meta.env.DEV ? error : undefined}
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
